// extracted by mini-css-extract-plugin
module.exports = {"slide":"SlideModal_style_slide__2fgMY"};